import {
    FETCH_ALL_CALLS_REQUEST,
    FETCH_ALL_CALLS_SUCCESS,
    FETCH_ALL_CALLS_FAILURE,
    FETCH_CALL_TRANSCRIPT_REQUEST,
    FETCH_CALL_TRANSCRIPT_SUCCESS,
    FETCH_CALL_TRANSCRIPT_FAILURE,
    SELECT_CALL,
    CLEAR_CALL_ERROR
} from '../Actions/Types';

const initialState = {
    // All calls list
    allCalls: [],
    isLoadingCalls: false,
    callsError: null,

    // Selected call with transcript
    selectedCall: null,
    callTranscript: null,
    isLoadingTranscript: false,
    transcriptError: null,

    // Metadata
    totalCalls: 0,
    lastFetchedAt: null
};

export default function callsReducer(state = initialState, action) {
    switch (action.type) {
        // Fetch all calls
        case FETCH_ALL_CALLS_REQUEST:
            return {
                ...state,
                isLoadingCalls: true,
                callsError: null
            };

        case FETCH_ALL_CALLS_SUCCESS:
            return {
                ...state,
                isLoadingCalls: false,
                allCalls: action.payload,
                totalCalls: action.payload.length,
                lastFetchedAt: new Date().toISOString(),
                callsError: null
            };

        case FETCH_ALL_CALLS_FAILURE:
            return {
                ...state,
                isLoadingCalls: false,
                callsError: action.payload,
                allCalls: []
            };

        // Fetch call transcript
        case FETCH_CALL_TRANSCRIPT_REQUEST:
            return {
                ...state,
                isLoadingTranscript: true,
                transcriptError: null
            };

        case FETCH_CALL_TRANSCRIPT_SUCCESS:
            return {
                ...state,
                isLoadingTranscript: false,
                selectedCall: action.payload,
                callTranscript: action.payload.transcript || [],
                transcriptError: null
            };

        case FETCH_CALL_TRANSCRIPT_FAILURE:
            return {
                ...state,
                isLoadingTranscript: false,
                transcriptError: action.payload,
                callTranscript: []
            };

        // Select call
        case SELECT_CALL:
            return {
                ...state,
                selectedCall: action.payload
            };

        // Clear errors
        case CLEAR_CALL_ERROR:
            return {
                ...state,
                callsError: null,
                transcriptError: null
            };

        default:
            return state;
    }
}
